document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.el-tab-slider__slider', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 800,
    autoHeight: true,
    watchOverflow: true,
    allowTouchMove: true,

    on: {
      init: updateProgress,
      slideChange: updateProgress,
      progress: updateProgress,
    },
  });

  function updateTabs(swiper) {
    const tabs = document.querySelectorAll('.el-tab-slider__tab');

    tabs.forEach(tab => tab.classList.remove('active'));

    const activeTab = tabs[swiper.realIndex];

    if (activeTab) activeTab.classList.add('active');
  }

  function updateProgress(swiper) {
    const fill = document.querySelector('.el-tab-slider__progress-fill');

    if (!fill) return;

    const current = swiper.realIndex + 1;
    const total = swiper.slides.length;

    const percent = (current / total) * 100;

    fill.style.width = percent + '%';

    updateTabs(swiper);
  }

  document.querySelectorAll('.el-tab-slider__tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      const index = Number(tab.dataset.index);
      swiper.slideTo(index);
    });
  });

  const statistics = document.querySelectorAll('.el-statistic');

  const animateCounter = (element, target) => {
    const duration = 1800;
    const start = performance.now();

    const update = (time) => {
      const progress = Math.min((time - start) / duration, 1);

      const easeOut = 1 - Math.pow(1 - progress, 3);

      const current = Math.floor(target * easeOut);

      element.innerHTML = `${current}<span class="el-statistic__percent">%</span>`;

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    };

    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, index) => {
        if (!entry.isIntersecting) return;

        setTimeout(() => {
          const stat = entry.target;

          stat.classList.add('is-visible');

          const circle = stat.querySelector('.el-statistic__progress');
          const value = stat.querySelector('.el-statistic__value');

          const percent =
            parseInt(
              stat
                .querySelector('.el-statistic__circle')
                .style.getPropertyValue('--percent'),
              10
            ) || 0;

          const radius = 54;
          const circumference = 2 * Math.PI * radius;

          const offset =
            circumference -
            (percent / 100) * circumference;

          circle.style.strokeDasharray = circumference;
          circle.style.strokeDashoffset = circumference;

          requestAnimationFrame(() => {
            circle.style.strokeDashoffset = offset;
          });

          if (!value.dataset.animated) {
            animateCounter(value, percent);
            value.dataset.animated = 'true';
          }
        }, index * 150);

        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.25,
    }
  );

  statistics.forEach((stat) => observer.observe(stat));
});